module.exports = __webpack_public_path__ + "static/img/banner.f53f6bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner.png
// module id = O9SZ
// module chunks = 1